angular.module('eStories.promoTerms', [
    'eStories.billing.model'
]).controller('PromoTermsCtrl', [
    'ModalsModel',
    'PromoModel',
    'AccountModel',
    'ValidationModel',
    '$state',
    '$uibModalInstance',
    function (ModalsModel,
              PromoModel,
              AccountModel,
              ValidationModel,
              $state,
              $uibModalInstance) {
        var promoTermsCtrl = this;

        if ($state.current.name == 'eStories.navbars.account.overview') {
            promoTermsCtrl.termsCopy = AccountModel.subscriptionDetails.promoPackage.termsCopy;
        } else {
            promoTermsCtrl.termsCopy = PromoModel.promoPackage.termsCopy;
        }

        promoTermsCtrl.closeModal = function () {
            $uibModalInstance.close();
        };
    }
]);
